import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'home.heading',
    defaultMessage: `
      COME IN<br />
      PLAY &<br />
      GET SMART
    `,
    description: 'Heading for Home section',
  },
  play: {
    id: 'home.play',
    defaultMessage: 'PLAY',
    description: 'Heading for Play section',
  },
  waltzingGames: {
    id: 'home.waltzingGames',
    defaultMessage: 'Waltzing Games',
    description: 'Subheading for Play section',
  },
  andLearn: {
    id: 'home.andLearn',
    defaultMessage: 'And Learn',
    description: 'Subheading for Play section',
  },
  getSmart: {
    id: 'home.getSmart',
    defaultMessage: 'GET SMART',
    description: 'Heading for Get Smart section',
  },
  ourServices: {
    id: 'home.ourServices',
    defaultMessage: 'Our Services',
    description: 'Heading for Our Services section',
  },
  ourProducts: {
    id: 'home.ourProducts',
    defaultMessage: 'Our Products',
    description: 'Subheading for Our Products section',
  },
  ourUsersSay: {
    id: 'home.ourUsersSay',
    defaultMessage: 'Our Users Say',
    description: 'Heading for Our Users Say section',
  },
  ourPartners: {
    id: 'home.ourPartners',
    defaultMessage: 'Our Partners & Customers',
    description: 'Heading for Our Partners & Customers section',
  },
});

export default messages;



// WEBPACK FOOTER //
// ./src/routes/home/messages.js